const m = require('air-vue-model')()
m.url = 'terminals'
m.name = 'terminal'
m.pk = 'uuid'
m.setPagination({ page_size: 'all' })
m.routes = [{ name: 'list', component: require('@/admin/views/terminals/TerminalList') }]
m.text = { listTitle: 'Киоски', itemTitle: 'Киоск' }
module.exports = m
